export enum TEXT_HIGHLIGHT_THEME {
  GENERIC = `generic`,
  LIGHT = `light`,
  INFORMATION = `information`,
  SUCCESS = `success`,
  DELETED = `deleted`,
  FAILED = `failed`,
  POSITIVE = `positive`,
  NEGATIVE = `negative`,
  NEUTRAL = `neutral`,
}
